import React from 'react';
import { useWinningArchive } from '../hooks/useWinningArchive';
import WinningAnalysisCard from '../components/WinningAnalysisCard';

const formatSectionDate = (value) => {
  try {
    return new Date(`${value}T12:00:00`).toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch (error) {
    return value;
  }
};

const groupByDate = (analyses) => analyses.reduce((groups, analysis) => {
  const sourceDate = analysis.match?.date || analysis.createdAt;
  const key = sourceDate ? new Date(sourceDate).toISOString().slice(0, 10) : 'unknown';

  if (!groups[key]) groups[key] = [];
  groups[key].push(analysis);
  return groups;
}, {});

const WinningArchivePage = () => {
  const { analyses, counts, loading, error, selectedDate, setSelectedDate, refetch } = useWinningArchive();
  const groupedAnalyses = groupByDate(analyses);
  const orderedDates = Object.keys(groupedAnalyses).sort((a, b) => b.localeCompare(a));

  if (loading) return <div className="loading">Tutan analizler yukleniyor...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="page analysis-page">
      <section className="hero-panel compact">
        <div className="hero-copy">
          <span className="hero-badge">Tutan Analizler</span>
          <h1 className="live-hero-title">BİTEN VE SONUÇ VEREN ANALİZLER TEK ARŞİVDE</h1>
          <p>Mac sonucu ile dogrulanmis, tutmus analizler burada otomatik olarak arsivlenir.</p>
        </div>
      </section>

      <section className="content-panel">
        <div className="dashboard-ribbon-grid">
          <div className="premium-stat-card">
            <span>Basarili Analiz</span>
            <strong>{counts.analyses}</strong>
          </div>
          <div className="premium-stat-card">
            <span>Durum</span>
            <strong>Canli Arsiv</strong>
          </div>
        </div>
      </section>

      <section className="content-panel">
        <div className="section-heading">
          <div>
            <h2>Tarih Filtrele</h2>
            <p>Tutan analizleri gun gun ayirip istediginiz tarihi acabilirsiniz.</p>
          </div>
          <div className="market-row archive-date-filter">
            <input
              type="date"
              value={selectedDate}
              onChange={(event) => setSelectedDate(event.target.value)}
            />
            <button type="button" className="btn-primary" onClick={refetch}>
              Yenile
            </button>
          </div>
        </div>
      </section>

      <section className="content-panel">
        <div className="section-heading">
          <div>
            <h2>Tutan Analizler</h2>
            <p>Mac sonucu ile dogrulanmis, tutmus analizler tarih tarih listelenir.</p>
          </div>
        </div>

        {analyses.length === 0 ? (
          <div className="empty">Henuz arsive giren tutan analiz yok.</div>
        ) : (
          <div className="winning-archive-sections">
            {orderedDates.map((dateKey) => (
              <div key={dateKey} className="winning-archive-date-group">
                <div className="winning-archive-date-head">
                  <span className="hero-badge">{formatSectionDate(dateKey)}</span>
                  <span className="confidence medium">{groupedAnalyses[dateKey].length} analiz</span>
                </div>
                <div className="analysis-grid winning-archive-grid">
                  {groupedAnalyses[dateKey].map((analysis) => (
                    <WinningAnalysisCard key={analysis.id} analysis={analysis} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default WinningArchivePage;
